var React = require('react');

function SmallArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.03.293l6.719 6.708-6.72 6.707-1.412-1.415 4.3-4.292H0V6h17.916l-4.3-4.293L15.03.293z","fill":"#E6E5E1"}));
}

SmallArrowInline.defaultProps = {"viewBox":"0 0 22 14","fill":"none"};

module.exports = SmallArrowInline;

SmallArrowInline.default = SmallArrowInline;
